import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CONFIG } from '../../../assets/config';
import { environment } from '../../../environments/environment';
import { ConfirmComponent } from '../../shared/components/confirm/confirm.component';
import sendDocumentsRequest from '../../shared/mocks/send-documents-request.mock.json';
import { ClaimStep } from '../../shared/models/claim-step';
import { SendDocumentsRequest } from '../../shared/models/dto/send-documents-request';
import { HomeserveService } from '../../shared/services/homeserve.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { StorageService } from '../../shared/services/storage.service';
import { ValidationService } from '../../shared/services/validation.service';
import { ClickToCallComponent } from '../click-to-call/click-to-call.component';
import { DataLayerService } from '../../core/services/dataLayer.service';
import { StateFiles } from '../../shared/models/dto/state-files';
import { StateListDocs } from '../../shared/models/dto/state-list-docs';
import { StepTrackerService } from '../../core/services/stepTracker.service';
import { MedalliaService } from '../../core/services/medallia.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
	selector: 'alta-siniestro',
	templateUrl: './alta-siniestro.component.html',
	styleUrls: ['./alta-siniestro.component.scss'],
	providers: [DataLayerService]
})
export class AltaSiniestroComponent {
	@Output() showC2CButton: EventEmitter<boolean> = new EventEmitter();
	readonly formKeyName: string = 'claimRegisterForm';
	formGroup: FormGroup = new FormGroup({});
	documentList: File[] = [];
	docListBase64: { [key: string]: string } = {};
	claimId: string = '';
	dateData: string = '';
	hourData: string = '';
	sendSuccessful: boolean = false;
	sendFail: boolean = false;
	failMessage: string | undefined = undefined;
	private modalOpen = false;
	maxDocumentSizeReached: boolean = false;
	confirmClaimData: any = this.storageService.get('confirmClaimForm');
	existNonPayment: boolean = false;
	claimNotConsolidated: boolean = false;
	finish: boolean = false;
	docs: any = [];
	filesSelected: string[] = [];
	acceptedFileType = '.pdf,.jpg,.jpeg,.bmp,.dib,.doc,.dot,.docx,.odt,.eml,.gif,.jpe,.jif,.jfif,.jfi,.msg,.png,.ppt,.pot,.pps,.ppa,.pptx,.thmx,.ppsx,.odp,.rft,.tif,.tiff,.txt,.text,.xls,.xlm,.xlsx,.ods,.csv,.avi,.qt,.mov,.mp4,.mp4v,.mpg4,.ogg,.wmv,.m4v,.3gpp,.flv,.mkv,.ewebm,.mppa,.mp2,.mp2a,.mp3,.m2a,.m3a,.ogg,.wav,.aif,.aiff,.aifc,.amr,.flac,.wma,.zip';
	typeFileNotAccept: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
		private homeserveService: HomeserveService,
		private storageService: StorageService,
		private masterService: MasterDataService,
		private translate: TranslateService,
		private validationService: ValidationService,
		private modalService: NgbModal,
		private dataLayerService: DataLayerService,
		private stepTrackerService : StepTrackerService,
		private medalliaService: MedalliaService,
		private oauthService: OAuthService
	) {
		this.homeserveService.claimStep = ClaimStep.ClaimRegister;
		this.showC2CButton.emit(false);
		this.initForm();
		this.dateData = `${this.confirmClaimData?.appointment.day}/${this.confirmClaimData?.appointment.month}/${this.confirmClaimData?.appointment.year}`;
		this.hourData = `${this.confirmClaimData?.appointment.startHour}h - ${this.confirmClaimData?.appointment.endHour}h`;
		this.existNonPayment = this.masterService.existNonPayment;
		this.claimNotConsolidated = this.masterService.claimNotConsolidated;
	}

	initForm() {
		const claimData: any = this.storageService.get(this.storageService.claimDataKey);
		this.docs = claimData.docList;
		this.claimId = this.homeserveService.getCurrentOpenClaim()?.openClaimResult.claimId ?? '';
		this.formGroup = this.formBuilder.group({
			documentList: [
				[],
				[
					/*Validators.required, this.validationService.fileSizeValidation*/
				]
			]
		});
		this.storageService.autoSaveForm(this.formKeyName, this.formGroup);
		sessionStorage.setItem('step', '4');
	}

	checkMaxFilesReached(files: File[]) {
		return (
			this.formGroup.get('documentList')?.value.length + files.length >	10
		);
	}

	deleteDocFile(fileName: string, id: string) {
		const objectToUpdate = this.docs.find((item: any) => item.id === id);
		if (objectToUpdate) {
			objectToUpdate.files.splice(objectToUpdate.files.findIndex((file:any) => file.name === fileName)
			, 1);
			let claimData: any = this.storageService.get(this.storageService.claimDataKey);
			claimData.docList = this.docs;
			this.storageService.save(this.storageService.claimDataKey, claimData);
		}
		this.documentList.splice(
			this.documentList.findIndex((file) => file.name === fileName),
			1
		);
		delete this.docListBase64[fileName];
		this.formGroup.get('documentList')?.setValue(this.documentList);
	}

	getSendDocumentsRequest(file: File, base64File: string, index:number): SendDocumentsRequest {
		let name = file.name.substring(0, file.name.lastIndexOf('.'));
		let extension = '';
		if (name === '') {
			name = file.name;
		} else {
			extension = file.name.substring(file.name.lastIndexOf('.'));
		}
		return environment.useMock
			? sendDocumentsRequest
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					claimId: this.claimId,
					receiver: 'C',
					message: file.name,
					fileName: name,
					fileExtension: extension,
					Description: this.docs[index].id + ' - '+this.translate.instant('docs.'+this.docs[index].id),
					Document: base64File,
					languageId: this.homeserveService.getSelectedLanguage().id,
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };
	}

	showLoadFilesError() {
		if (this.modalOpen) {
			return;
		}
		this.modalOpen = true;
		const modalRef = this.modalService.open(ConfirmComponent, {
			windowClass: 'modal-small',
			centered: true,
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.title = this.translate.instant('common.error');
		modalRef.componentInstance.body = this.translate.instant('claimRegistering.tooManyFiles');
		modalRef.componentInstance.buttonText = this.translate.instant('common.back');
		modalRef.result.then(
			(result) => {
				this.modalOpen = false;
			},
			(reason) => {
				//  Dismiss
				this.modalOpen = false;
			}
		);
	}

	checkTypeFile(fileExtension : string) : boolean {
		if(fileExtension){
			fileExtension = fileExtension.trim();
			const arrayAcceptedFileType = this.acceptedFileType.split(',');
			const fileType = arrayAcceptedFileType.find((fileType: string) => fileType === fileExtension);
			if(fileType){
				return true;
			}
		}
		return false;
	}

	updateDocumentList(event: any, id: string) {
		if (this.checkMaxFilesReached(event.target.files)) {
			this.showLoadFilesError();
		} else {
			const files: FileList = event.target.files;
			if (Array.from(files).some((file) => file.size > 1048576 * 10)) {
				this.maxDocumentSizeReached = true;
			} else {
				this.maxDocumentSizeReached = false;
				Array.from(files).forEach((file) => {
					//PSI-1580 INI
					if(files && file.size <= 0){
						return;
					}
					//PSI-1580 END
  					const fileName: string = file.name;
					const fileExtension: string | undefined = fileName.split('.').pop()?.toLowerCase();
					if (this.checkTypeFile('.' + fileExtension)) {
						if (!this.documentList.some((docFile) => file.name === docFile.name)) {
							const objectToUpdate = this.docs.find((item: any) => item.id === id);
							if (objectToUpdate) {
								objectToUpdate.files.push({name:file.name, state: StateFiles.Pending});
								let claimData: any = this.storageService.get(this.storageService.claimDataKey);
								claimData.docList = this.docs;
								this.storageService.save(this.storageService.claimDataKey, claimData);
							}
							this.documentList.push(file);
							const fileBase64 = new FileReader();
							fileBase64.readAsDataURL(file);
							fileBase64.onload = () => {
								const result = fileBase64.result as string;
								this.docListBase64[file.name] = result.split(',')[1] ?? '';
							};
						}
					} else {
						this.typeFileNotAccept = true;
						setInterval(() => {
							this.typeFileNotAccept = false;
						}, 10000);
					}
				});
				this.formGroup.get('documentList')?.setValue(this.documentList);
			}
		}
	}

	callSendDocuments() {
		if (this.documentList.length > 0) {
		  this.documentList.forEach((file: File) => {
			const fileExtension = file.name.split('.').pop()?.toLowerCase();
			const fileSizeBytes = file.size;
			const fileSizeDisplay = this.formatFileSize(fileSizeBytes);
			const isSuccessful = true;
	  
			this.stepTrackerService.updateNameEvent('modulo_hogar_paso_4');
			const currentNameEvent = this.stepTrackerService.getCurrentEventName();
			this.dataLayerService.addDataToDataLayer({
			  'event': currentNameEvent,
			  'eventData_total_results': isSuccessful ? 'OK' : 'KO',
			  'eventData_document_type': isSuccessful ? fileExtension : '',
			  'eventData_document_size': isSuccessful ? fileSizeDisplay : ''
			});
	  
			const eventLabel = `${isSuccessful ? 'OK' : 'KO'}_${isSuccessful ? fileExtension : 'unknown'}_${isSuccessful ? fileSizeDisplay : ''}`;
	  
			this.dataLayerService.addDataToDataLayer({
			  'event': 'uaevent',
			  'eventCategory': 'Funnel Hogar Siniestros',
			  'eventAction': 'modulo_hogar_document_upload',
			  'eventLabel': eventLabel
			});
		  });
		}
	  
		this.documentList.forEach((file: File) => {
		  if (this.docs && this.docs.length && this.docs.length > 0) {
			for (let index = 0; index < this.docs.length; index++) {
			  const doc = this.docs[index].files.find((item: any) => item.name === file.name);
			  if (doc && doc.state !== StateFiles.Sent) {
				this.callHomeserveSendDocs(file, this.docListBase64[file.name], index);
			  }
			}
		  }
		});
	  }
	  
	  formatFileSize(fileSizeBytes: number): string {
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	  
		if (fileSizeBytes === 0) return '0 Byte';
	  
		const i = Math.floor(Math.log(fileSizeBytes) / Math.log(1024));
	  
		return (Math.round(fileSizeBytes / Math.pow(1024, i) * 100) / 100).toFixed(2) + ' ' + sizes[i];
	  }
	  
	  
	  

	callHomeserveSendDocs(file: File, base64File: string, index:number) {
		this.homeserveService.sendDocuments(this.getSendDocumentsRequest(file, base64File,index)).subscribe({
			next: (response) => {
				if("statusCode" in response) {
					if(this.docs && this.docs.length && this.docs.length > 0) {
						for(let i = 0 ; i < this.docs.length ; i++){
							if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
								const doc = this.docs[i].files.find((item: any) => item.name === file.name);
								if(doc){
									doc.state = StateFiles.Fail;
								}
							}
						}
					}
					const modalRef = this.modalService.open(ClickToCallComponent, {
						centered: true,
						windowClass: 'modal-call',
						backdrop: 'static',
						keyboard: false
					});
					modalRef.componentInstance.motiveC2C = response.statusCode;
					modalRef.componentInstance.submotiveC2C = 'Fallo en el envío de documentos.';
					this.sendFail = true;
					this.sendSuccessful = false;
				}
				else if("sendDocumentsResult" in response){
					if(response.sendDocumentsResult.codError && response.sendDocumentsResult.codError !== '000'){
						/* response.sendDocumentsResult.TypeError !== '80001' ? 
								this.masterService.manageSendDocumentsControlledErrors(response.sendDocumentsResult) :
								(this.failMessage = response.sendDocumentsResult.error); */
						if(this.docs && this.docs.length && this.docs.length > 0) {
							for(let i = 0 ; i < this.docs.length ; i++){
								if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
									const doc = this.docs[i].files.find((item: any) => item.name === file.name);
									if(doc){
										doc.state = StateFiles.Fail;
									}
								}
							}
						}
						this.sendFail = true;
						this.sendSuccessful = false;
					}
					else{
						if(this.docs && this.docs.length && this.docs.length > 0) {
							for(let i = 0 ; i < this.docs.length ; i++){
								if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
									const doc = this.docs[i].files.find((item: any) => item.name === file.name);
									if(doc){
										doc.state = StateFiles.Sent;
									}
								}
							}
						}
						this.sendSuccessful = true;
						this.sendFail = false;
					}
				} else {
					if(this.docs && this.docs.length && this.docs.length > 0) {
						for(let i = 0 ; i < this.docs.length ; i++) {
							if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
								const doc = this.docs[i].files.find((item: any) => item.name === file.name);
								if(doc){
									doc.state = StateFiles.Fail;
								}
							}
						}
					}
					this.sendFail = true;
					this.sendSuccessful = false;
				}
				
				
			},
			error: (error) => {
				if(this.docs && this.docs.length && this.docs.length > 0) {
					for(let i = 0 ; i < this.docs.length ; i++){
						if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
							const doc = this.docs[i].files.find((item: any) => item.name === file.name);
							if(doc){
								doc.state = StateFiles.Fail;
							}
						}
					}
				}
				this.sendFail = true;
				this.sendSuccessful = false;
			}
		});
	}

	base64FilesLoaded() {
		return (
			!this.documentList.some((file) => !this.docListBase64[file.name] || this.docListBase64[file.name] === '')
		);
	}

	sendDataToMedallia() {

		const confirmData: any = this.storageService.get(this.storageService.confirmDataKey);
		const decision = this.homeserveService.getCurrentDecisionTree();


		let Tipo_siniestro = confirmData?.sendFixer ? (confirmData.isExistsRepair ? 'Mixto' : 'Reparable') : 'Indemnizable'
		let Causa_siniestro = decision?.causeCia ?? ''; 

		this.medalliaService.setValue("Tipo_siniestro",Tipo_siniestro);  
		this.medalliaService.setValue("Causa_siniestro",Causa_siniestro); 
		

		if(this.claimNotConsolidated || ((!this.claimId || this.claimId === '') && !this.claimNotConsolidated)){
			// ESCENARIO Apertura siniestro con retención. El botón Finalizar tras visualizarse el banner gris
			this.medalliaService.setValue("Exito_siniestro",1);
			this.medalliaService.setValue("CodigoMDM_value",this.oauthService.getIdentityClaims()['id_mdm']);
			this.medalliaService.setValue("Siniestro_declarado",0);
			this.medalliaService.setValue("Tipo_finalizacion","CDUGRIS");
		} else if(this.existNonPayment) {
			// ESCENARIO Apertura siniestro con impago. El botón Finalizar tras visualizarse el banner rojo
			this.medalliaService.setValue("Exito_siniestro",1);
			this.medalliaService.setValue("CodigoMDM_value",this.oauthService.getIdentityClaims()['id_mdm']);
			this.medalliaService.setValue("Siniestro_declarado",1);
			this.medalliaService.setValue("Tipo_finalizacion","CDUIMPA");
		} else {
			//ESCENARIOS OK
			

			if(this.claimId && Tipo_siniestro === 'Indemnizable' && !this.isAnyDocSent()){
				/* ESCENARIO Apertura siniestro con Indemnizable OK. 
				 El botón Finalizar habiendo obtenido nº de siniestro, sin banner rojo ni gris y sin subir documentos
				 (SE ENTIENDE SIN SUBIR DOCUMENTACION COMO NO HABER ENVIADO EXITOSAMENTE AL MENOS 1 DOCUMENTO)*/
				this.medalliaService.setValue("Exito_siniestro",1);
				this.medalliaService.setValue("CodigoMDM_value", this.oauthService.getIdentityClaims()['id_mdm']);
				this.medalliaService.setValue("Siniestro_declarado",1);
				this.medalliaService.setValue("Tipo_finalizacion","CDUPUNO");
			}

			if(this.claimId && Tipo_siniestro === 'Indemnizable' && this.isAnyDocSent()){
				/* ESCENARIO Apertura siniestro con Indemnizable OK. 
				El botón Finalizar habiendo obtenido nº de siniestro, sin banner rojo ni gris y habiendo subido algún documento
				(SE ENTIENDE SIN SUBIR DOCUMENTACION COMO NO HABER ENVIADO EXITOSAMENTE AL MENOS 1 DOCUMENTO) */
				this.medalliaService.setValue("Exito_siniestro",1);
				this.medalliaService.setValue("CodigoMDM_value", this.oauthService.getIdentityClaims()['id_mdm']);
				this.medalliaService.setValue("Siniestro_declarado",1);
				this.medalliaService.setValue("Tipo_finalizacion","CDUPUSI");
			}

			if(Tipo_siniestro === 'Reparable' && this.masterService.appointment){
				/* ESCENARIO Apertura siniestro reparable OK con cita. */ 
				this.medalliaService.setValue("Exito_siniestro",1);
				this.medalliaService.setValue("CodigoMDM_value", this.oauthService.getIdentityClaims()['id_mdm']);
				this.medalliaService.setValue("Siniestro_declarado",1);
				this.medalliaService.setValue("Tipo_finalizacion","CDURESI");
			}

			if(Tipo_siniestro === 'Reparable' && !(this.masterService.appointment)){
				/* ESCENARIO Apertura siniestro reparable OK con sin cita.
				Da igual si ha sido elección del cliente o ejecución del sistema */ 
				this.medalliaService.setValue("Exito_siniestro",1);
				this.medalliaService.setValue("CodigoMDM_value", this.oauthService.getIdentityClaims()['id_mdm']);
				this.medalliaService.setValue("Siniestro_declarado",1);
				this.medalliaService.setValue("Tipo_finalizacion","CDURENO");
			}

			if(Tipo_siniestro === 'Mixto' && !this.isAnyDocSent()){
				/* ESCENARIO Apertura siniestro con Mixto OK. 
				El botón Finalizar habiendo obtenido nº de siniestro, sin banner rojo ni gris y sin subir documentos.
				Independiente de la situación de cita/no cita */ 
				this.medalliaService.setValue("Exito_siniestro",1);
				this.medalliaService.setValue("CodigoMDM_value", this.oauthService.getIdentityClaims()['id_mdm']);
				this.medalliaService.setValue("Siniestro_declarado",1);
				this.medalliaService.setValue("Tipo_finalizacion","CDUMXNO");
			}

			if(Tipo_siniestro === 'Mixto' && this.isAnyDocSent()){
				/* ESCENARIO Apertura siniestro con Mixto OK. 
				El botón Finalizar habiendo obtenido nº de siniestro, sin banner rojo ni gris y habiendo subido algún documento.
				Independiente de la situación de cita/no cita */ 
				this.medalliaService.setValue("Exito_siniestro",1);
				this.medalliaService.setValue("CodigoMDM_value", this.oauthService.getIdentityClaims()['id_mdm']);
				this.medalliaService.setValue("Siniestro_declarado",1);
				this.medalliaService.setValue("Tipo_finalizacion","CDUMXSI");
			}

			

		}
		this.medalliaService.callMedallia();
	}

	finishAndBye() {
		this.finish = true;
		this.showC2CButton.emit(false);
		sessionStorage.setItem('step', 'finish');

		this.stepTrackerService.updateStep('4');
		const currentStep = this.stepTrackerService.getCurrentStep();
		this.dataLayerService.addDataToDataLayer({
			'event': 'uaevent',
			'eventCategory': 'Funnel Hogar Siniestros',
			'eventAction': 'modulo_hogar',
			'eventLabel': `Step${currentStep}`
		  });


		  //IPD-81
		this.sendDataToMedallia();
	  }
	  
	getListDocsState() : StateListDocs{
		let retorno = StateListDocs.NoState;

		if(this.isListDocsStateOk()){
			retorno = StateListDocs.Ok;
		} else if(this.isListDocsStateFail()){
			retorno = StateListDocs.Error;
		} else if(this.isListDocsStatePartial()){
			retorno = StateListDocs.Partial;
		} 

		return retorno;
	}

	isListDocsFilesExist() : boolean {
		let retorno:boolean = false;
		if(this.docs && this.docs.length && this.docs.length > 0){
			for(let i = 0 ; i < this.docs.length ; i++) {
				if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
					retorno = true;
					
				}
			}
		}

		return retorno;
	}


	
	isListDocsStateOk() : boolean {
		let retorno:boolean = false;
		
		if(this.docs && this.docs.length && this.docs.length > 0){
			let allFiles: any [] = [];
			for(let i = 0 ; i < this.docs.length ; i++) {
				if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
					this.docs[i].files.forEach((file:any) => {
						allFiles.push(file);
					});
					
				}
			}
			
			if(allFiles && allFiles.length && allFiles.length > 0){
				const docFail = allFiles.find((item: any) => item.state === StateFiles.Fail);
				if(docFail) {
					retorno = false;
				} else {
					const docSent = allFiles.find((item: any) => item.state === StateFiles.Sent);
					if(docSent){
						retorno = true;
					} else {
						retorno = false;
					}
				}
			}
		}

		return retorno;
	}

	isListDocsStateFail() : boolean {
		let retorno:boolean = false;
		
		if(this.docs && this.docs.length && this.docs.length > 0){
			let allFiles: any [] = [];
			for(let i = 0 ; i < this.docs.length ; i++) {
				if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
					this.docs[i].files.forEach((file:any) => {
						allFiles.push(file);
					});
				}
			}

			if(allFiles && allFiles.length && allFiles.length > 0){
				const docSent = allFiles.find((item: any) => item.state === StateFiles.Sent);
				if(docSent) {
					retorno = false;
				} else {
					const docFail = allFiles.find((item: any) => item.state === StateFiles.Fail);
					if(docFail){
						retorno = true;
					} else {
						retorno = false;
					}
				}
			}
		}

		return retorno;
	}

	isListDocsStatePartial() : boolean {
		let retorno:boolean = false;
		
		if(this.docs && this.docs.length && this.docs.length > 0){
			let allFiles: any [] = [];
			for(let i = 0 ; i < this.docs.length ; i++) {
				if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
					this.docs[i].files.forEach((file:any) => {
						allFiles.push(file);
					});
				}
			}

			if(allFiles && allFiles.length && allFiles.length > 0){
				const docFail = allFiles.find((item: any) => item.state === StateFiles.Fail);
				const docOk = allFiles.find((item: any) => item.state === StateFiles.Sent);
				if(docFail && docOk ) {
					retorno = true;
				} else {
					retorno = false;
				}
			}
		}

		return retorno;
	}

	isAnyDocPending() : boolean {
		let retorno:boolean = false;
		
		if(this.docs && this.docs.length && this.docs.length > 0){
			let allFiles: any [] = [];
			for(let i = 0 ; i < this.docs.length ; i++) {
				if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
					this.docs[i].files.forEach((file:any) => {
						allFiles.push(file);
					});
				}
			}
			
			if(allFiles && allFiles.length && allFiles.length > 0){
				const doc = allFiles.find((item: any) => item.state === StateFiles.Pending);
				if(doc) {
					retorno = true;
				} else {
					retorno = false;
				}
			}
		}

		return retorno;
	}

	isAnyDocFail() : boolean {
		let retorno:boolean = false;
		
		if(this.docs && this.docs.length && this.docs.length > 0){
			let allFiles: any [] = [];
			for(let i = 0 ; i < this.docs.length ; i++) {
				if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
					this.docs[i].files.forEach((file:any) => {
						allFiles.push(file);
					});
				}
			}
			
			if(allFiles && allFiles.length && allFiles.length > 0){
				const docFail = allFiles.find((item: any) => item.state === StateFiles.Fail);
				if(docFail) {
					retorno = true;
				} else {
					retorno = false;
				}
			}
		}

		return retorno;
	}

	isAnyDocSent() : boolean {
		let retorno:boolean = false;
		
		if(this.docs && this.docs.length && this.docs.length > 0){
			let allFiles: any [] = [];
			for(let i = 0 ; i < this.docs.length ; i++) {
				if(this.docs[i] && this.docs[i].files && this.docs[i].files.length && this.docs[i].files.length > 0){
					this.docs[i].files.forEach((file:any) => {
						allFiles.push(file);
					});
				}
			}
			
			if(allFiles && allFiles.length && allFiles.length > 0){
				const docFail = allFiles.find((item: any) => item.state === StateFiles.Sent);
				if(docFail) {
					retorno = true;
				} else {
					retorno = false;
				}
			}
		}

		return retorno;
	}
}
